/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Sortbyplaceholder3Inputs */

const en_coinvestments_filters_sortbyplaceholder3 = /** @type {(inputs: Coinvestments_Filters_Sortbyplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default order`)
};

/**
* | output |
* | --- |
* | "Default order" |
*
* @param {Coinvestments_Filters_Sortbyplaceholder3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_sortbyplaceholder3 = /** @type {((inputs?: Coinvestments_Filters_Sortbyplaceholder3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Sortbyplaceholder3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_sortbyplaceholder3(inputs)
});
export { coinvestments_filters_sortbyplaceholder3 as "coInvestments_filters_sortByPlaceholder" }